/**
 * @internal
 */
export const PANE_DEBUG = false

/**
 * @internal
 */
export const PANE_COLLAPSED_WIDTH = 51

/**
 * @internal
 */
export const PANE_DEFAULT_MIN_WIDTH = PANE_COLLAPSED_WIDTH * 4
